import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const deleteAudience = createAsyncThunk(
    "deleteAudience",
    async ({ audienceId }, thunkAPI) => {
      try {
        const apiClient = new APIClient();
        const response = await apiClient.delete(`/api/v1/management/audience/${audienceId}/delete`);

        if (response.status === true) {
          return { success: true, message: "The audience has been successfully deleted." };
        } else {
          return thunkAPI.rejectWithValue({ success: false, message: "Failed to delete the audience." });
        }
      } catch (error) {
        console.error('API call error:', error.message);
        return thunkAPI.rejectWithValue({ success: false, message: error.message || "API call failed." });
      }
    }
);

export const deleteAudienceSlice = createSlice({
  name: "deleteAudienceSlice",
  initialState: {
    isLoading: false,
    success: false,
    message: '',
  },
  extraReducers: {
    [deleteAudience.pending]: (state) => {
        state.isLoading = true;
        state.success = false;
        state.message = '';
    },
    [deleteAudience.fulfilled]: (state, action) => {
        state.isLoading = false;
        state.success = action.payload.success;
        state.message = action.payload.message;
    },
    [deleteAudience.rejected]: (state, action) => {
        state.isLoading = false;
        state.success = action.payload?.success || false;
        state.message = action.payload?.message || "Failed to delete audience.";
    },
  },
});

export default deleteAudienceSlice.reducer;
